<div class="d-flex justify-content-center mb-2" *ngIf="loading">
  <i class="fas fa-spinner fa-spin fa-3x"></i>
</div>

<form #replyForm="ngForm" class="flex-column" (ngSubmit)="replyForm.valid && send()">
  <th-member-details
    *ngIf="patient"
    labelColumnClass="col-md-2"
    inputColumnClass="col-md-10"
    [memberId]="memberId"
  ></th-member-details>

  <div class="form-group form-row required">
    <label for="recipients" class="col-md-2 col-form-label">To</label>
    <div class="col-md-10">
      <div class="recipients-container">
        <ng-select
          [items]="recipientList | async"
          [typeahead]="recipientInput"
          [multiple]="true"
          [loading]="searchingRecipients"
          [compareWith]="compareSelectedItem"
          [(ngModel)]="recipients"
          [ngModelOptions]="{ standalone: true }"
          (add)="onRecipientAddRemove($event.value, true)"
          (remove)="onRecipientAddRemove($event.value, false)"
          (clear)="clearRecipients()"
          bindLabel="display"
          labelForId="recipients"
          clearAllText="Clear"
          placeholder="Add a new recipient"
          name="recipients"
          class="custom"
        />

        <div *ngIf="memberId" ngbDropdown autoClose="outside" class="dropdown ms-2">
          <button type="button" class="btn btn-primary btn-sm dropdown-toggle" ngbDropdownToggle>Care Team</button>
          <div ngbDropdownMenu class="dropdown-menu">
            <div class="form-check dropdown-item border-bottom" ngbDropdownItem>
              <input
                type="checkbox"
                class="form-check-input"
                name="careTeam_selectAll"
                id="careTeam_selectAll"
                [(ngModel)]="allCareTeamMembersSelected"
                (ngModelChange)="selectAllCareTeamMembers()"
              />
              <label class="form-check-label" for="careTeam_selectAll">Select All</label>
            </div>
            <div
              *ngFor="let careTeamMember of careTeamMembers; index as i"
              class="form-check dropdown-item"
              ngbDropdownItem
            >
              <input
                type="checkbox"
                class="form-check-input"
                name="careTeam_{{ i }}"
                id="careTeam_{{ i }}"
                [(ngModel)]="careTeamMember.selected"
                (ngModelChange)="selectCareTeamMember(careTeamMember)"
              />
              <label class="form-check-label" for="careTeam_{{ i }}">{{ careTeamMember.formattedName }}</label>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="replyForm.submitted && (recipients == null || recipients.length === 0)" class="invalid-feedback">
        {{ errors?.selectedUserName }}
      </div>
    </div>
  </div>

  <div class="form-group form-row" *ngIf="sendMessageHelpText">
    <div class="offset-md-2 col-md-10">
      <i>{{ sendMessageHelpText }}</i>
    </div>
  </div>

  <ng-container *ngIf="patient">
    <div class="form-group form-row required">
      <label for="messageSubject" class="col-md-2 col-form-label">Message Subject</label>
      <div class="col-md-10">
        <select
          class="form-select"
          id="messageSubject"
          name="messageSubject"
          [(ngModel)]="sendMessage.subject"
          (ngModelChange)="onSubjectChange()"
          #subject="ngModel"
          required
        >
          <option [ngValue]="null">Please select...</option>
          <option *ngFor="let subject of subjects" [ngValue]="subject">{{ subject }}</option>
        </select>

        <div *ngIf="replyForm.submitted && subject.invalid" class="invalid-feedback">Please enter a valid subject</div>
      </div>
    </div>

    <div *ngIf="showOtherSubject" class="form-group form-row required">
      <label for="otherSubject" class="col-md-2 col-form-label">Other Subject</label>
      <div class="col-md-10">
        <input
          type="text"
          name="otherSubject"
          id="otherSubject"
          [(ngModel)]="sendMessage.otherSubject"
          class="form-control"
          #otherSubject="ngModel"
          required
        />

        <div *ngIf="replyForm.submitted && otherSubject.invalid" class="invalid-feedback">
          Please enter a valid subject
        </div>
      </div>
    </div>
  </ng-container>

  <div class="form-group form-row">
    <label for="tags" class="col-md-2 col-form-label">Tags</label>
    <div class="col-md-10">
      <ng-select
        [items]="tags"
        [multiple]="true"
        [addTag]="addTag"
        [(ngModel)]="tagArray"
        [ngModelOptions]="{ standalone: true }"
        bindLabel="display"
        bindValue="value"
        labelForId="tags"
        placeholder="Select tags"
        clearAllText="Clear"
        class="custom"
      />
    </div>
  </div>
  <div class="form-group form-row required">
    <label for="message" class="col-md-2 col-form-label">Message</label>
    <div class="col-md-10">
      <textarea
        class="form-control"
        name="message"
        [(ngModel)]="sendMessage.message"
        #message="ngModel"
        id="message"
        rows="10"
        [maxlength]="messageMaxLength"
        required
        thNotEmptyValidator
      ></textarea>
      <div>{{ sendMessage?.message | characterCount: messageMaxLength }}</div>
      <div *ngIf="replyForm.submitted && message?.invalid" class="invalid-feedback">
        {{ errors?.message }}
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [thLoadingIndicator]="submitting">Send</button>
    <button type="button" class="btn btn-outline-primary" (click)="modalService.dismissAll()">Cancel</button>
  </div>
</form>
